import React from "react";
import "../../Assessts/Styles/Publications.scss";
import Brochures from "./Brochures";
import AnnualReports from "./AnnualReports";
import IOText from "../../ReUableComponents/ImageOntext";
import PBanner from "../../Assessts/Images/Publications/Publications.png";
const Publications = () => {
    return (
        <>
            <div className="Single_Banner mt-2">
                <IOText Image={PBanner} Alt="EMpower" Text={<div className="Text-MainDiv" >
                    <div></div>
                    <div ><span style={{ color: "#F7D670" }}>Documenting learning outcomes </span>and driving evidence-based educational improvement</div>
                    <div className="mt-2 Text-Content" >
                        <span style={{ color: "#F7D670" }}> Home  </span>   &gt;    Publications
                    </div>
                </div>} />
            </div>
            <Brochures />
            <AnnualReports/>
        </>
    );
};
export default Publications;